import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-tag-aria-label-dismiss': {
    'ar-AE': 'تجاهل',
    'bn-IN': 'বাতিল করুন',
    'cs-CZ': 'Odmítnout',
    'da-DK': 'Afvis',
    'de-DE': 'Verwerfen',
    'en-AE': 'Dismiss',
    'en-AU': 'Dismiss',
    'en-CA': 'Dismiss',
    'en-GB': 'Dismiss',
    'en-IN': 'Dismiss',
    'en-NG': 'Dismiss',
    'en-SG': 'Dismiss',
    'en-US': 'Dismiss',
    'en-ZA': 'Dismiss',
    'es-CL': 'Descartar',
    'es-CO': 'Descartar',
    'es-ES': 'Descartar',
    'es-MX': 'Descartar',
    'es-US': 'Descartar',
    'fr-BE': 'Ignorer',
    'fr-CA': 'Ignorer',
    'fr-FR': 'Ignorer',
    'he-IL': 'ביטול',
    'hi-IN': 'खारिज करें',
    'it-IT': 'Ignora',
    'ja-JP': '取り消す',
    'kn-IN': 'ವಜಾಗೊಳಿಸಿ',
    'ko-KR': '해제',
    'ml-IN': 'നിരസിക്കുക',
    'mr-IN': 'डिसमिस करा',
    'nl-BE': 'Negeren',
    'nl-NL': 'Negeren',
    'pl-PL': 'Odrzuć',
    'pt-BR': 'Ignorar',
    'pt-PT': 'Ignorar',
    'sv-SE': 'Avvisa',
    'ta-IN': 'நிராகரி',
    'te-IN': 'రద్దుచేయండి',
    'tr-TR': 'Kaldır',
    'zh-CN': '关闭',
    'zh-TW': '關閉',
  },
  'kat-tag-aria-label-select': {
    'ar-AE': 'تحديد',
    'bn-IN': 'নির্বাচন করুন',
    'cs-CZ': 'Vybrat',
    'da-DK': 'Vælg',
    'de-DE': 'Auswählen',
    'en-AE': 'Select',
    'en-AU': 'Select',
    'en-CA': 'Select',
    'en-GB': 'Select',
    'en-IN': 'Select',
    'en-NG': 'Select',
    'en-SG': 'Select',
    'en-US': 'Select',
    'en-ZA': 'Select',
    'es-CL': 'Seleccionar',
    'es-CO': 'Seleccionar',
    'es-ES': 'Seleccionar',
    'es-MX': 'Seleccionar',
    'es-US': 'Seleccionar',
    'fr-BE': 'Sélectionner',
    'fr-CA': 'Sélectionner',
    'fr-FR': 'Sélectionner',
    'he-IL': 'בחירה',
    'hi-IN': 'चुनें',
    'it-IT': 'Seleziona',
    'ja-JP': '選択する',
    'kn-IN': 'ಆಯ್ಕೆಮಾಡಿ',
    'ko-KR': '선택',
    'ml-IN': 'തിരഞ്ഞെടുക്കുക',
    'mr-IN': 'निवडा',
    'nl-BE': 'Selecteren',
    'nl-NL': 'Selecteren',
    'pl-PL': 'Wybierz',
    'pt-BR': 'Selecionar',
    'pt-PT': 'Selecionar',
    'sv-SE': 'Välj',
    'ta-IN': 'தேர்ந்தெடு',
    'te-IN': 'ఎంపిక చేసుకోండి',
    'tr-TR': 'Seç',
    'zh-CN': '选择',
    'zh-TW': '選擇',
  },
};

export default katTranslator(strings);
